import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { IoCloseOutline } from 'react-icons/io5';
import './SavedFileImage.css';

// Only recognize our file route, never attach credentials to a Markdown URL.
export function savedImageFileId(src, apiUrl = process.env.REACT_APP_ATLAS_AGENT_API_URL) {
  if (typeof src !== 'string') return null;
  try {
    let path = src;
    if (!src.startsWith('/v1/')) {
      if (!apiUrl) return null;
      const url = new URL(src);
      if (url.origin !== new URL(apiUrl).origin) return null;
      path = url.pathname;
    }
    return /^\/v1\/saved-files\/([a-zA-Z0-9_-]+)\/download(?:[?#].*)?$/.exec(path)?.[1] || null;
  } catch { return null; }
}

export default function SavedFileImage({ fileId, file, label, loadPreview }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const scope = file?.library_scope_type;
  const scopeId = file?.library_scope_id;
  const companyId = file?.company_id;
  useEffect(() => {
    let active = true;
    let objectUrl;
    setUrl(null);
    setError(false);
    setOpen(false);
    Promise.resolve().then(() => loadPreview({ fileId, file: {
      library_scope_type: scope, library_scope_id: scopeId, company_id: companyId,
    } })).then((value) => {
      if (!active) { URL.revokeObjectURL(value); return; }
      objectUrl = value;
      setUrl(value);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId, scope, scopeId, companyId, loadPreview, attempt]);
  return <span className="atlas-photo-preview">
    {error ? <span role="status">Photo preview unavailable. <button type="button" onClick={() => setAttempt((n) => n + 1)}>Retry preview</button></span>
      : url ? <button type="button" className="atlas-photo-open" aria-label={`Enlarge ${label}`} onClick={() => setOpen(true)}>
        <img src={url} alt={label} onError={() => setError(true)} />
      </button> : <span role="status">Loading photo…</span>}
    <Dialog open={open && Boolean(url)} onClose={() => setOpen(false)} maxWidth="xl" fullWidth>
      <DialogTitle>{label}<IconButton aria-label="Close photo" onClick={() => setOpen(false)} sx={{ float: 'right' }}><IoCloseOutline /></IconButton></DialogTitle>
      <DialogContent><img className="atlas-photo-full" src={url || undefined} alt={label} /></DialogContent>
    </Dialog>
  </span>;
}
